import { Message, SendFile } from "../../models/Message";
import { MyNotifs } from "../../services/MyNotifs";

export class UIMessage {
  sendFiles: File[] = [];
  isLocal: boolean = false;
  isNewDay: boolean = false;

  constructor(public msg: Message, public children: UIMessage[]) {
  }

  replyCount: number = 0;
  lastReply: Message | null = null;
  repliesLoaded: boolean = false;
  unreadReplyCount: number = 0;

  isNew() {
    return MyNotifs.NotificationsByMessage.get(this.msg.id)?.isNew ?? false;
  }

  // setOpened(value: boolean) {
  //   this.opened = value;
  //   if(value) {
  //     Current.MessageReadStatus.set(this.msg.id, true);
  //   } else {
  //     Current.MessageReadStatus.delete(this.msg.id);
  //   }
  // }
  nonReactions(): UIMessage[] {
    return this.children.filter(c => !c.msg.emoticon);
  }

  reactions(): UIMessage[] {
    const reactionMap = new Map<string, UIMessage>();

    this.children.filter(c => c.msg.emoticon).forEach(c => {
      const userId = c.msg.user?.id;
      if (!userId) return;

      const existing = reactionMap.get(userId);
      if (!existing) {
        reactionMap.set(userId, c);
      } else {
        // 더 최신 데이터로 교체 (created 시간이 같거나 더 크면 교체)
        const newTime = new Date(c.msg.created).getTime();
        const oldTime = new Date(existing.msg.created).getTime();
        // 로컬에서 방금 생성한 메시지는 created가 현재 시간이므로 가장 최신일 것임
        if (newTime >= oldTime) {
          reactionMap.set(userId, c);
        }
      }
    });

    return Array.from(reactionMap.values());
  }

  /**
   * 불변성을 유지하면서 자식 메시지를 추가한 새 UIMessage 반환
   */
  withChild(child: UIMessage): UIMessage {
    const newMsg = new UIMessage(this.msg, [...this.children, child]);
    // 🔧 리액션(emoticon)은 댓글 수/마지막 답글에 반영하지 않음
    const isReaction = !!child.msg.emoticon;
    newMsg.replyCount = isReaction ? this.replyCount : this.replyCount + 1;
    newMsg.lastReply = isReaction ? this.lastReply : child.msg;
    newMsg.repliesLoaded = this.repliesLoaded;
    newMsg.isNewDay = this.isNewDay;
    newMsg.unreadReplyCount = this.unreadReplyCount;
    newMsg.sendFiles = this.sendFiles;
    newMsg.isLocal = this.isLocal;
    return newMsg;
  }

  /**
   * 불변성을 유지하면서 children을 교체한 새 UIMessage 반환
   */
  withChildren(children: UIMessage[]): UIMessage {
    const newMsg = new UIMessage(this.msg, children);
    // 🔧 리액션(emoticon)은 댓글 수/마지막 답글에서 제외
    const replyChildren = children.filter(c => !c.msg.emoticon);
    newMsg.replyCount = replyChildren.length;
    newMsg.lastReply = replyChildren.length > 0 ? replyChildren[replyChildren.length - 1].msg : null;
    newMsg.repliesLoaded = true;
    newMsg.isNewDay = this.isNewDay;
    newMsg.unreadReplyCount = this.unreadReplyCount;
    newMsg.sendFiles = this.sendFiles;
    newMsg.isLocal = this.isLocal;
    return newMsg;
  }

  /**
   * 불변성을 유지하면서 isLocal 상태를 변경한 새 UIMessage 반환
   */
  withLocalStatus(isLocal: boolean): UIMessage {
    const newMsg = new UIMessage(this.msg, this.children);
    newMsg.isLocal = isLocal;
    newMsg.isNewDay = this.isNewDay;
    newMsg.replyCount = this.replyCount;
    newMsg.lastReply = this.lastReply;
    newMsg.repliesLoaded = this.repliesLoaded;
    newMsg.unreadReplyCount = this.unreadReplyCount;
    newMsg.sendFiles = isLocal ? this.sendFiles : []; // 전송 완료 시 업로드 프리뷰 제거
    return newMsg;
  }
}


